import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'react-slidedown/lib/slidedown.css'
import Dropdown from '../../../dropdown'
import config from '../../../../config'

import { AuthGDPR } from '../common/AuthGDPR'
import { AuthResponsable } from '../common/AuthResponsable'

import { AuthCompromis, AuthCompromisMenors16 } from './AuthCompromis'
import { AuthImatgeMaterial } from './AuthImatgeMaterial'
import { AuthDretsImatge } from './AuthDretsImatge'
import { AuthSortides } from './AuthSortides'
import { AuthMedica } from './AuthMedica'
import { AuthParacetamol } from './AuthParacetamol'
import { AuthReligio } from './AuthReligio'
import { AuthValEscolar } from './AuthValEscolar'
import { AuthAbsentisme } from './AuthAbsentisme'
import { AuthAlternanca } from './AuthAlternanca'
import { AuthAMPA } from './AuthAMPA'

export function EnrolmentFormAuthorizations(props) {

  const [errors, setErrors] = useState({});

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  /* AUTORITZACIONS */
  const [authorizationsOpen, setAuthorizationsOpen] = useState(true);

  const toggleAuthorizationsOpen = () => {
    setAuthorizationsOpen(!authorizationsOpen);
  }

  const [authIntranet, setAuthIntranet ] = useState(false);
  const [authPublicacions, setAuthPublicacions ] = useState(false);
  const [authMaterial, setAuthMaterial ] = useState(false);
  const [authMaterialInicials, setAuthMaterialInicials ] = useState(false);
  const [authInternet, setAuthInternet ] = useState(false);

  const [authDretsImatge , setAuthDretsImatge ] = useState("1");

  const [authCompromis, setAuthCompromis ] = useState("0");
  const [authGDPR, setAuthGDPR ] = useState("0");
  const [authSortides, setAuthSortides ] = useState("0");
  const [authAMPA, setAuthAMPA ] = useState("0");
  const [authMedica, setAuthMedica] = useState("0");
  const [authParacetamol, setAuthParacetamol ] = useState("0");
  const [authGimnas, setAuthGimnas ] = useState("0");
  const [authReligio, setAuthReligio ] = useState("0");
  const [authAbsentisme, setAuthAbsentisme] = useState("0");
  const [authAlternanca, setAuthAlternanca ] = useState("0");
  const [authResponsable, setAuthResponsable ] = useState("0");
  const [authValEscolar, setAuthValEscolar] = useState("0");

  const [dadesAutoritzacions, setDadesAutoritzacions] = useState({validat: false});

  const handleDadesAutoritzacions = (noError) => {
    let d = {
     "validat": noError,

    /* DADES AUTORITZACIONS */
    "authIntranet": authIntranet,
    "authPublicacions": authPublicacions,
    "authMaterial": authMaterial,
    "authMaterialInicials": authMaterialInicials,
    "authInternet": authInternet,
    "authCompromis": authCompromis,
    "authGDPR": authGDPR,
    "authDretsImatge": authDretsImatge,
    "authSortides": authSortides,
    "authAMPA": authAMPA,
    "authMedica": authMedica,
    "authParacetamol": authParacetamol,
    "authGimnas": authGimnas,
    "authReligio": authReligio,
    "authAbsentisme": authAbsentisme,
    "authAlternanca": authAlternanca,
    "authResponsable": authResponsable,
    "authValEscolar": authValEscolar,
    }

      setDadesAutoritzacions(d)
      props.handleDadesAutoritzacions(d)
    }


  const validaAuthIntranet = () => {
    return authIntranet ? null : "Heu d'indicar una resposta"
  }

  const validaAuthPublicacions= () => {
    return authPublicacions ? null : "Heu d'indicar una resposta"
  }

  const validaAuthMaterial= () => {
    return authMaterial ? null : "Heu d'indicar una resposta"
  }

  const validaAuthMaterialInicials = () => {
    return authMaterialInicials ? null : "Heu d'indicar una resposta"
  }

  const validaAuthDretsImatge = () => {
    //només obligatori pels menors de 14
    //if(props.dadesPersonals.edat >= 14 ) return null
    return authDretsImatge ? null : "Heu d'indicar una resposta"
  }

  const validaAuthReligio= () => {
    return authReligio === "0" ? "Heu d'indicar una opció" : null
  }

  const validaAuthInternet= () => {
    return authInternet ? null : "Heu d'indicar una resposta"
  }

  const validaAuthCompromis = () => {
    return authCompromis === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthGDPR= () => {
    return authGDPR === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthSortides= () => {
    return authSortides === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthMedica= () => {
    return authMedica === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthAlternanca= () => {
    return authAlternanca === "1" ? null : "Aquest camp és obligatori"
  }

  const validaValEscolar = () => {
    return authValEscolar === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthResponsable= () => {
    return authResponsable === "1" ? null : "Aquest camp és obligatori"
  }

 const handleChangeIntranet = (t) => { setAuthIntranet(t) }
 const handleChangePublicacions = (t) => { setAuthPublicacions(t) }
 const handleChangeMaterial = (t) => { setAuthMaterial(t) }
 const handleChangeMaterialInicials = (t) => { setAuthMaterialInicials(t) }
 const handleChangeInternet = (t) => { setAuthInternet(t) }
 const handleChangeDretsImatge = (t) => { setAuthDretsImatge(t) }

 const handleChangeCompromis = (t) => {

      setAuthCompromis(t === "0" ? "1" : "0")

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeGDPR = (t) => {

      setAuthGDPR(t === "0" ? "1" : "0")

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeResponsable = (t) => {

      setAuthResponsable(t === "0" ? "1" : "0")

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeSortides = (t) => {

      setAuthSortides(t === "0" ? "1" : "0")

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeAMPA= (t) => {

      setAuthAMPA(t === "0" ? "1" : "0")

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeMedica= (t) => {

      setAuthMedica(t === "0" ? "1" : "0")

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeParacetamol = (t) => {

      setAuthParacetamol(t === "0" ? "1" : "0")

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeGimnas = (t) => {

      setAuthGimnas(t === "0" ? "1" : "0")

      if(t === "1") handleDadesAutoritzacions(false)
 }


 const handleChangeReligio = (t) => {

    // valor de t: "1" o "2"
     setAuthReligio(t)

     handleDadesAutoritzacions(false)
 }

 const handleChangeAbsentisme = (t) => {

      setAuthAbsentisme(t === "0" ? "1" : "0")

     handleDadesAutoritzacions(false)
 }

 const handleChangeValEscolar = (t) => {

      setAuthValEscolar(t === "0" ? "1" : "0")

     handleDadesAutoritzacions(false)
 }

 const handleChangeAlternanca = (t) => {

      setAuthAlternanca(t === "0" ? "1" : "0")

     handleDadesAutoritzacions(false)
 }




/* VALIDA AUTORITZACIONS */
const validaAutoritzacions = (e) => {
  if(e) e.preventDefault();

  let error = {}

  if (props.dadesPersonals.edat >= 14) {

    //només obligatori pels majors de 14
    error.authIntranet = validaAuthIntranet();
    handleErrors('authIntranet', error)

    error.authPublicacions = validaAuthPublicacions();
    handleErrors('authPublicacions', error)

    error.authMaterial = validaAuthMaterial();
    handleErrors('authMaterial', error)

    error.authMaterialInicials = validaAuthMaterialInicials();
    handleErrors('authMaterialInicials', error)

    error.authInternet = validaAuthInternet();
    handleErrors('authInternet', error)

  } else {

    //només obligatori pels menors de 14
    error.authDretsImatge = validaAuthDretsImatge();
    handleErrors('authDretsImatge', error)

  }

  error.authCompromis = validaAuthCompromis();
  handleErrors('authCompromis',error)

  error.authGDPR = validaAuthGDPR();
  handleErrors('authGDPR',error)

  error.authResponsable = validaAuthResponsable();
  handleErrors('authResponsable',error)

  error.authMedica = validaAuthMedica();
  handleErrors('authMedica',error)

  if (props.dadesPersonals.edat < 18) {
    error.authSortides = validaAuthSortides();
    handleErrors('authSortides',error)
  }

  if(props.dadesEstudis.curs.id.startsWith("ESOLOE"))
  {
    error.authReligio = validaAuthReligio();
    handleErrors('authReligio',error)
  }

  if (props.dadesEstudis.curs.id.startsWith("ESOLOE") || props.dadesEstudis.curs.id.startsWith("CFPB"))
  {
    error.authValEscolar = validaValEscolar();
    handleErrors('authValEscolar',error)
  }

  if (props.dadesEstudis.curs.id.startsWith("CFPM") || props.dadesEstudis.curs.id.startsWith("CFPS"))
  {
    error.authAlternanca = validaAuthAlternanca();
    handleErrors('authAlternanca',error)
  }


  setErrors(error)

  let noError = true;
  //DEVELOP
  if(!config.develop) // bypass errors if develop == true
  {
    Object.keys(error).map( (k) => { if(error[k] !== null) noError = false } )
  }

  console.log('ERROR',error,noError);

  handleDadesAutoritzacions(noError)

  if(noError)
  {
     setAuthorizationsOpen(false);
  }

  return noError;
}

  return (
    <div className="container authorizations">
      <div className="row">
        <div className="col col-12 ">
          <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">
            <div className="t-Region-header">
              <div className="t-Region-headerItems  t-Region-headerItems--controls">
                <button
                  className="t-Button t-Button--icon t-Button--hideShow"
                  type="button"
                  onClick={toggleAuthorizationsOpen}
                >
                  {authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronUp}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                  {!authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                </button>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--title">
                <h2 className="t-Region-title a-Collapsible-heading">
                  Protecció de dades
                </h2>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
            </div>
            <div className="t-Region-bodyWrap">
              <Dropdown open={authorizationsOpen}>
                <div className="t-Region-body a-Collapsible-content">
                  <div className="container">
                    <div className="row">
                      <div className="col col-12 ">
                        <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                          <div className="t-Region-bodyWrap">
                            <div className="t-Region-body">
                              <div className="container">

                                   { props.dadesPersonals.edat >= 16 ? (
                                     <AuthCompromis auth={authCompromis} handleChange={handleChangeCompromis} error={errors.authCompromis} enguany={props.enguany} anyVinent={props.anyVinent} />
                                   ) : (
                                     <AuthCompromisMenors16 auth={authCompromis} handleChange={handleChangeCompromis} error={errors.authCompromis} enguany={props.enguany} anyVinent={props.anyVinent} />
                                   )
                                  }

<br/>
<br/>
{ props.dadesPersonals.edat >= 14 ? (
                                  <AuthImatgeMaterial
                                    enguany={props.enguany} anyVinent={props.anyVinent}
                                    authIntranet={authIntranet} handleChangeIntranet={handleChangeIntranet} errorIntranet={errors.authIntranet}
                                    authPublicacions={authPublicacions} handleChangePublicacions={handleChangePublicacions} errorPublicacions={errors.authPublicacions}
                                    authInternet={authInternet} handleChangeInternet={handleChangeInternet} errorInternet={errors.authInternet}
                                    authMaterial={authMaterial} handleChangeMaterial={handleChangeMaterial} errorMaterial={errors.authMaterial}
                                    authMaterialInicials={authMaterialInicials} handleChangeMaterialInicials={handleChangeMaterialInicials} errorMaterialInicials={errors.authMaterialInicials}
                                  />
                                )
                                :
                                (
                                  <AuthDretsImatge auth={authDretsImatge} handleChange={handleChangeDretsImatge} error={errors.authDretsImatge} enguany={props.enguany} anyVinent={props.anyVinent} />
                                )
                              }
                                      <br/>

                                <AuthGDPR auth={authGDPR} handleChange={handleChangeGDPR} error={errors.authGDPR} />

                                { props.dadesPersonals.edat < 18 && (
                                  <AuthSortides auth={authSortides} handleChange={handleChangeSortides} error={errors.authSortides} />
                                )}

                                      <br/>

                                  <AuthMedica auth={authMedica} handleChange={handleChangeMedica} error={errors.authMedica} />

                                      <br/>

                                  <AuthParacetamol auth={authParacetamol} handleChange={handleChangeParacetamol} error={errors.authParacetamol} />

                                      <br/>

                                    {/*<div className="row">
                                      <div className="col col-12 ">
                                        <h4>
                                          Autorització per a activitats esportives
                                        </h4>
                                        <p>
                                          Jo, com a responsable legal que soc d’ell/ella, he fet tot el que calia per conèixer el seu estat de salut; per tant, <br/><br/>
                                          <input type="checkbox" id="authGimnas" name="authGimnas" value={authGimnas} checked={authGimnas === "1" ? true : false} onChange={(t) => { handleChangeGimnas(t.target.value) }} required />
                                          <label htmlFor="authGimnas"> AUTORITZO que faci els exercicis de gimnàstica i les activitats esportives pròpies de la seva edat (exempta, si és el cas, les que s’indiquen en el certificat mèdic oficial que us adjunto).  </label>
                                          <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authGimnas}</span>
                                        </p>

                                      </div>
                                    </div>

                                <br />*/
                                }


                                {/* AUTORITZACIONS ESPECIFIQUES ESO */}
                                {props.dadesEstudis.curs.id.startsWith("ESOLOE") && (
                                  <AuthReligio auth={authReligio} handleChange={handleChangeReligio} error={errors.authReligio} />
                                )}

                                { (props.dadesEstudis.curs.id.startsWith("ESOLOE") || props.dadesEstudis.curs.id.startsWith("CFPB")) &&
                                (
                                  <AuthValEscolar auth={authValEscolar} handleChange={handleChangeValEscolar} error={errors.authValEscolar} />
                                )}

                                {/* AUTORITZACIONS ESPECIFIQUES 3r i 4t ESO */}
                                { (props.dadesEstudis.curs.id === "ESOLOE03"
                                    || props.dadesEstudis.curs.id === "ESOLOE04"
                                    || props.dadesEstudis.curs.id.startsWith("BATXLOE")

                                    ) && (
                                  <AuthAbsentisme auth={authAbsentisme} handleChange={handleChangeAbsentisme} error={errors.authAbsentisme} />
                                )
                                }

                                {/* AUTORITZACIONS ESPECIFIQUES CICLES */}
                                { ( props.dadesEstudis.curs.id.startsWith("CFPM") || props.dadesEstudis.curs.id.startsWith("CFPS") ) && (
                                  <AuthAlternanca auth={authAlternanca} handleChange={handleChangeAlternanca} error={errors.authAlternanca} />
                                )
                                }


                                  <AuthAMPA auth={authAMPA} handleChange={handleChangeAMPA} error={errors.authAMPA} />

                                      <br/>

                                <AuthResponsable auth={authResponsable} handleChange={handleChangeResponsable} error={errors.authResponsable} />

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="container">
                            <div className="row">
                              <div className="col col-12" align="center">
                                <button onClick={validaAutoritzacions} className="button">SEGÜENT</button>
                              </div>
                            </div>
                          </div>

                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
